var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.145 5.41S2.914 0 9 0c6.084 0 8.854 5.386 8.854 5.386L18 5.67l-.145.287s-2.769 5.41-8.855 5.41c-6.084 0-8.854-5.385-8.854-5.385L0 5.698l.145-.288zm16.4.262C16.12 4.925 13.813 1.263 9 1.263c-4.815 0-7.122 3.687-7.545 4.434.425.746 2.731 4.408 7.545 4.408 4.815 0 7.122-3.686 7.545-4.433zM9.042 2.514c-1.744 0-3.172 1.421-3.172 3.158 0 1.736 1.428 3.158 3.172 3.158 1.744 0 3.172-1.422 3.172-3.158 0-1.737-1.428-3.158-3.172-3.158zm1.903 3.158a1.89 1.89 0 00-1.903-1.895A1.89 1.89 0 007.14 5.672a1.89 1.89 0 001.903 1.895 1.89 1.89 0 001.903-1.895z",
    fill: "#6373A4"
  })));
}

export default SvgPasswordHidden;